let id = 0;

export default function uniqueId(prefix: string = '') {
    // eslint-disable-next-line no-plusplus
    return `${prefix}${++id}`;
}
